import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=bd534dc6"
var script = {}
import style0 from "./Products.vue?vue&type=style&index=0&id=bd534dc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports